export const environment = {
  production: true,
  supabaseUrl: 'https://vszbhwvaecpvogaplrnk.supabase.co',
  supabaseKey: 'sb_publishable_60cBgQWhqc4UFJfqZF7kJw_ogKQDlc9',
};
